import { useContext } from 'react';
import useScript from '../../hooks/useScript';
import ConfigContext from '../../contexts/ConfigContext';

const MBox = () => {
  const { MBOX_URL } = useContext(ConfigContext);

  useScript(
    MBOX_URL
  );

  return null;
};

export default MBox;
